module.exports = __webpack_public_path__ + "img/django.69c3103a.png";